/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * PRODUCT IMAGE LIGHTBOX
 * Clicking a product photo opens it full screen (replaces the theme's hover zoom). Arrows / swipe move between the
 * product's photos; Esc, the close button or clicking the backdrop closes it.
 */
(function() {
  var lightbox = null;
  var imageElement = null;
  var counterElement = null;
  var sources = [];
  var currentIndex = 0;
  var pointerStart = null;

  function build() {
    lightbox = document.createElement('div');
    lightbox.className = 'meq-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image');
    lightbox.hidden = true;
    lightbox.innerHTML =
      '<button type="button" class="meq-lightbox__close" data-lightbox-close aria-label="Close">&times;</button>' +
      '<button type="button" class="meq-lightbox__nav meq-lightbox__nav--prev" data-lightbox-prev aria-label="Previous image">&#8249;</button>' +
      '<img class="meq-lightbox__image" alt="">' +
      '<button type="button" class="meq-lightbox__nav meq-lightbox__nav--next" data-lightbox-next aria-label="Next image">&#8250;</button>' +
      '<span class="meq-lightbox__counter"></span>';

    document.body.appendChild(lightbox);
    imageElement = lightbox.querySelector('.meq-lightbox__image');
    counterElement = lightbox.querySelector('.meq-lightbox__counter');

    lightbox.addEventListener('click', function(event) {
      if (event.target.closest('[data-lightbox-prev]')) {
        show(currentIndex - 1);
      } else if (event.target.closest('[data-lightbox-next]')) {
        show(currentIndex + 1);
      } else if (event.target === lightbox || event.target.closest('[data-lightbox-close]')) {
        close();
      }
    });

    // Swipe left / right on phones
    lightbox.addEventListener('touchstart', function(event) {
      pointerStart = event.touches[0].clientX;
    }, { passive: true });

    lightbox.addEventListener('touchend', function(event) {
      if (pointerStart === null) {
        return;
      }

      var distance = event.changedTouches[0].clientX - pointerStart;
      pointerStart = null;

      if (Math.abs(distance) > 50) {
        show(currentIndex + (distance < 0 ? 1 : -1));
      }
    });
  }

  function show(index) {
    currentIndex = (index + sources.length) % sources.length;
    imageElement.src = sources[currentIndex].src;
    imageElement.alt = sources[currentIndex].alt;
    counterElement.textContent = (currentIndex + 1) + ' / ' + sources.length;
    lightbox.classList.toggle('meq-lightbox--single', sources.length < 2);
  }

  function open(images, index) {
    if (!lightbox) {
      build();
    }

    sources = images;
    show(index);
    lightbox.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    lightbox.querySelector('[data-lightbox-close]').focus();
  }

  function close() {
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('keydown', function(event) {
    if (!lightbox || lightbox.hidden) {
      return;
    }

    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'ArrowLeft') {
      show(currentIndex - 1);
    } else if (event.key === 'ArrowRight') {
      show(currentIndex + 1);
    }
  });

  // Ignore the click that ends a swipe through the gallery carousel
  var downPosition = null;

  document.addEventListener('pointerdown', function(event) {
    downPosition = { x: event.clientX, y: event.clientY };
  });

  document.addEventListener('click', function(event) {
    // Product photos, or any photo inside a [data-meq-zoom-group] (e.g. the Our Work gallery)
    var clickedImage = event.target.closest('.product-gallery__carousel .product-gallery__image, [data-meq-zoom-group] img');

    if (!clickedImage) {
      return;
    }

    if (downPosition && (Math.abs(event.clientX - downPosition.x) > 10 || Math.abs(event.clientY - downPosition.y) > 10)) {
      return;
    }

    var galleryImages;

    if (clickedImage.classList.contains('product-gallery__image')) {
      galleryImages = Array.prototype.slice.call(clickedImage.closest('.product-gallery__carousel').querySelectorAll('.product-gallery__carousel-item:not(.is-filtered) .product-gallery__image'));
    } else {
      galleryImages = Array.prototype.slice.call(clickedImage.closest('[data-meq-zoom-group]').querySelectorAll('img'));
    }

    var images = galleryImages.map(function(image) {
      // Use the theme's zoom image, or ask Shopify's CDN for a large version of the photo
      var source = image.getAttribute('data-zoom') || (image.currentSrc || image.src).replace(/([?&])width=\d+/, '$1width=1800');
      return { src: source, alt: image.getAttribute('alt') || '' };
    });

    event.preventDefault();
    open(images, Math.max(0, galleryImages.indexOf(clickedImage)));
  });
})();

/**
 * ON SALE BADGE (snippets/meq-sale-badge.liquid)
 * Shows "On sale · Save $X" for the selected variant and hides it when the variant isn't discounted.
 */
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var badge = event.target.querySelector('[data-meq-sale]');

  if (!badge) {
    return;
  }

  var onSale = variant && variant.compare_at_price > variant.price;
  badge.hidden = !onSale;

  if (onSale) {
    var saving = variant.compare_at_price - variant.price;
    badge.querySelector('[data-meq-sale-amount]').innerHTML = meqFormatMoney(saving);
    badge.querySelector('[data-meq-sale-was]').innerHTML = meqFormatMoney(variant.compare_at_price);
  }
});

/**
 * STOCK STATUS (snippets/meq-stock-status.liquid)
 * Shows "In stock" or "Back order – ETA" for the selected variant, sends the back order note with the order, and
 * tags option buttons whose every variant is on back order.
 */
(function() {
  document.querySelectorAll('[data-meq-stock-json]').forEach(function(jsonElement) {
    var data = JSON.parse(jsonElement.textContent);
    var form = jsonElement.closest('form');
    var statusElement = form.querySelector('[data-meq-stock]');
    var textElement = form.querySelector('[data-meq-stock-text]');
    var propertyInput = form.querySelector('[data-meq-stock-property]');
    var section = form.closest('[data-section-type="product"]') || document;

    function update(variantId) {
      var variant = data.variants[variantId];
      var state = variant ? variant.state : 'order';

      statusElement.classList.remove('meq-stock--stock', 'meq-stock--order', 'meq-stock--backorder');
      statusElement.classList.add('meq-stock--' + state);
      textElement.textContent = data.texts[state];
      propertyInput.disabled = state !== 'backorder';
    }

    // Tag option values (e.g. a colour) when every variant with that value is on back order
    var variantList = Object.keys(data.variants).map(function(id) {
      var variant = data.variants[id];
      // Option tags only for variants staff have flagged as back order, not everything that's simply out of stock
      variant.backOrder = variant.flagged === true;
      return variant;
    });

    section.querySelectorAll('.product-form__single-selector').forEach(function(selector) {
      var position = parseInt(selector.getAttribute('data-option-position'), 10) - 1;
      var isBackOrder = function(value) {
        var matching = variantList.filter(function(variant) { return variant.options[position] === value; });
        return matching.length > 0 && matching.every(function(variant) { return variant.backOrder; });
      };

      if (selector.tagName === 'SELECT') {
        Array.prototype.forEach.call(selector.options, function(option) {
          if (isBackOrder(option.value)) {
            option.textContent = option.value + ' (' + data.badge + ')';
          }
        });
      } else if (isBackOrder(selector.value)) {
        var label = section.querySelector('label[for="' + selector.id + '"]');

        if (label && label.classList.contains('meq-colour__swatch')) {
          // Round colour swatches get a small clock badge instead of a text tag
          label.classList.add('meq-colour__swatch--back-order');
          label.title = selector.value + ' (' + data.badge + ')';
        } else if (label && !label.querySelector('.meq-option-badge')) {
          var badge = document.createElement('span');
          badge.className = 'meq-option-badge';
          badge.textContent = data.badge;
          label.appendChild(badge);
        }
      }
    });

    var idInput = form.querySelector('[name="id"]');
    update(idInput ? idInput.value : null);

    section.addEventListener('variant:changed', function(event) {
      if (event.detail.variant) {
        update(event.detail.variant.id);
      }
    });
  });
})();

// Format cents the same way as the theme's "money_without_trailing_zeros" ($110, $95.50, $1,250)
function meqFormatMoney(cents) {
  var amount = (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return (window.theme.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
}

/**
 * PRICE IN THE ADD TO CART BUTTON
 * Shows "Add to cart · $495" on product forms. The add-ons code below updates it to the running total.
 */
function meqSetButtonPrice(form, cents) {
  var button = form && form.querySelector('.product-form__add-button[data-action="add-to-cart"]');

  // Leave sold out / unavailable buttons alone (the theme sets their own text)
  if (!button || button.disabled || button.hasAttribute('disabled')) {
    return;
  }

  var label = (window.languages && window.languages.productFormAddToCart) || 'Add to cart';
  button.innerHTML = label + '<span class="meq-button-price"> · ' + meqFormatMoney(cents) + '</span>';
}

(function() {
  document.querySelectorAll('[data-section-type="product"]').forEach(function(section) {
    var form = section.querySelector('form[action*="/cart/add"]');
    var jsonElement = section.querySelector('[data-product-json]');

    if (!form || !jsonElement) {
      return;
    }

    try {
      var data = JSON.parse(jsonElement.textContent);
      var selected = data.product.variants.filter(function(variant) { return variant.id === data.selected_variant_id; })[0];

      if (selected) {
        meqSetButtonPrice(form, selected.price);
      }
    } catch (error) {
      return;
    }

    section.addEventListener('variant:changed', function(event) {
      if (event.detail.variant) {
        meqSetButtonPrice(form, event.detail.variant.price);
      }
    });
  });
})();

/**
 * PRODUCT ADD-ONS (snippets/product-add-ons.liquid)
 * Turns the product's "Price" line into a running total of the main product plus the ticked add-ons, and adds the
 * ticked add-ons to the cart together with the main product when "Add to cart" is clicked.
 */
(function() {
  var box = document.querySelector('[data-product-add-ons]');

  if (!box) {
    return;
  }

  var form = box.closest('form[action*="/cart/add"]');
  var mainPrice = parseInt(box.getAttribute('data-main-price'), 10) || 0;
  var priceListElement = form.querySelector('.product-form__info-item--price .price-list');
  var priceLabelElement = form.querySelector('.product-form__info-item--price .product-form__info-title');
  var errorElement = box.querySelector('[data-add-on-error]');

  // The theme's own price markup (incl. any sale price), shown again when no add-on is ticked
  var originalPriceHtml = priceListElement ? priceListElement.innerHTML : '';
  var originalPriceLabel = priceLabelElement ? priceLabelElement.textContent : '';

  function getCheckedAddOns() {
    return Array.prototype.slice.call(box.querySelectorAll('[data-add-on-variant]:checked'));
  }

  function getMainQuantity() {
    var quantityInput = form.querySelector('[name="quantity"]');
    return Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
  }

  function updateTotal() {
    if (!priceListElement) {
      return;
    }

    var checked = getCheckedAddOns();

    if (checked.length === 0) {
      priceListElement.innerHTML = originalPriceHtml;
      priceLabelElement.textContent = originalPriceLabel;
      meqSetButtonPrice(form, mainPrice * getMainQuantity());
      return;
    }

    var total = mainPrice * getMainQuantity();

    checked.forEach(function(checkbox) {
      total += parseInt(checkbox.getAttribute('data-price'), 10);
    });

    priceListElement.innerHTML = '<span class="price">' + meqFormatMoney(total) + '</span>' +
      '<span class="meq-price-note">incl. ' + checked.length + (checked.length === 1 ? ' accessory' : ' accessories') + '</span>';
    priceLabelElement.textContent = 'Total:';
    meqSetButtonPrice(form, total);
  }

  function showError(message) {
    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  function postToCart(body, isJson) {
    return fetch(window.routes.cartAddUrl + '.js', {
      body: body,
      credentials: 'same-origin',
      method: 'POST',
      headers: isJson ? { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } : { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (response.ok) {
        return response;
      }

      return response.json().then(function(content) {
        throw new Error(content['description'] || 'Sorry, this could not be added to your cart.');
      });
    });
  }

  // Drop-down add-ons (e.g. cable lengths): the chosen option sets the row's variant and price, and ticks the row
  box.addEventListener('change', function(event) {
    var select = event.target.closest('[data-add-on-select]');
    if (!select) {
      return;
    }
    var row = select.closest('[data-add-on]');
    var option = select.options[select.selectedIndex];
    var checkbox = row.querySelector('[data-add-on-variant]');
    checkbox.value = option.value;
    checkbox.setAttribute('data-price', option.getAttribute('data-price'));
    checkbox.checked = true;
    row.querySelector('[data-add-on-price]').textContent = option.getAttribute('data-price-label');
  }, true);

  box.addEventListener('change', updateTotal);

  // The main product price changes with its variant, and its quantity buttons do not fire any event
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;

    if (!variant) {
      return;
    }

    mainPrice = variant.price;

    // Same markup as the theme's own price update, so it can be restored when add-ons are unticked
    if (variant.compare_at_price > variant.price) {
      originalPriceHtml = '<span class="price price--highlight"><span class="visually-hidden">' + window.languages.productSalePrice + '</span>' + meqFormatMoney(variant.price) + '</span>' +
        '<span class="price price--compare"><span class="visually-hidden">' + window.languages.productRegularPrice + '</span>' + meqFormatMoney(variant.compare_at_price) + '</span>';
    } else {
      originalPriceHtml = '<span class="price"><span class="visually-hidden">' + window.languages.productSalePrice + '</span>' + meqFormatMoney(variant.price) + '</span>';
    }

    updateTotal();
  });

  form.addEventListener('click', function() { setTimeout(updateTotal, 0); });
  form.addEventListener('keyup', updateTotal);
  form.addEventListener('focusout', updateTotal);

  // Runs before the theme's own add to cart (capture phase), only when at least one add-on is ticked
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="add-to-cart"]');
    var checked = getCheckedAddOns();

    if (!button || !form.contains(button) || checked.length === 0) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var mainQuantity = getMainQuantity();
    var addOnItems = checked.map(function(checkbox) {
      return { id: parseInt(checkbox.value, 10), quantity: parseInt(checkbox.getAttribute('data-qty'), 10) || 1 };
    });

    errorElement.hidden = true;
    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    // The main product is posted as the form itself, so anything else in the form (e.g. app fields) is kept
    postToCart(new FormData(form), false).then(function() {
      return postToCart(JSON.stringify({ items: addOnItems }), true);
    }).then(function() {
      button.removeAttribute('disabled');

      if (window.theme.cartType === 'page') {
        window.location.href = window.routes.cartUrl;
        return;
      }

      // Let the theme re-render and open the mini-cart
      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: null,
          quantity: mainQuantity + addOnItems.reduce(function(sum, item) { return sum + item.quantity; }, 0)
        }
      }));
    }).catch(function(error) {
      button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      showError(error.message);

      // Something may have been added before the error, so make sure the mini-cart is up to date
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }, true);

  updateTotal();
})();
